export default __webpack_public_path__ + "static/media/ToyotaType-SemiboldIt.d687cb81.ttf";